import { UI_COLORLS } from '@/constants';

/**
 * Маппинг для иконок
 *
 * @type {Object}
 */
export const ICONS_MAP = {
  advertViews: 'fi-eye',
  favorites:   'fi-like',
  phoneViews:  'fi-mobile',
  calls:       'fi-phone-filled',
  callRequest: 'fi-call-center',
};

/**
 * Цвета для графиков
 *
 * @type {Object}
 */
export const CHART_COLOR = {
  advertViews: UI_COLORLS.greenLight,
  phoneViews:  UI_COLORLS.blueLight,
  calls:       UI_COLORLS.blueDarkest,
  callRequest: UI_COLORLS.blueDarker,
};

/**
 * Дефолтное значение задержки, после которой должна появляться ошибка
 *
 * @type {number}
 */
export const DEFAULT_TIMEOUT = 15000;

/**
 * Минимальное кол-во дней, после которых доступно скачивание отчета
 *
 * @type {number}
 */
export const MIN_DAYS_NB = 6;
